export default __webpack_public_path__ + "static/media/AshrieTechBanner.dd6c4d0e.png";